import { render } from "./EvalvationQuestionnaireQuestionImprovements.vue?vue&type=template&id=89da8386"
import script from "./EvalvationQuestionnaireQuestionImprovements.vue?vue&type=script&lang=js"
export * from "./EvalvationQuestionnaireQuestionImprovements.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__